import { Skeleton } from "@/components/ui/skeleton";
import type { FC } from "react";

const skeletonWidths: readonly string[] = ["w-24", "w-40", "w-64", "w-48"];
const SECTIONS_COUNT = 4;

export const FaqsSkeleton: FC = () => (
  <div className="pt-8 space-y-6" data-testid="faqs-skeleton">
    {Array.from({ length: SECTIONS_COUNT }).map((_, sectionIdx) => (
      <div key={sectionIdx} className="space-y-2">
        {skeletonWidths.map((width) => (
          <Skeleton key={width} className={`h-6 ${width}`} />
        ))}
      </div>
    ))}
  </div>
);
